import React, { useEffect, useState } from "react";
import { paginateData, calculateTotalPages } from "../../../assets/js/script";
import TableHeader from "../../Common/TableComponent/TableHeader";
import EntriesDropdown from "../../Common/TableComponent/EntriesDropdown";
import TablesRow from "../../Common/TableComponent/TablesRow";
import { Pagination } from "../../Common/TableComponent/Pagination";
import { AddCoupon } from "./AddCoupon";
import { Loading } from "../../Common/OtherElements/Loading";
import Swal from "sweetalert2";
import { confirmDelete } from "../../Common/OtherElements/confirmDeleteClone";
import { TableDataStatusError } from "../../Common/OtherElements/TableDataStatusError";
import { handleErrors } from "../../../utils/errorHandler";
import { usePageLevelAccess } from "../../../hooks/usePageLevelAccess";
import { useNavigate } from "react-router-dom";
import {
  fetchCouponCodes,
  deleteCouponCode,
} from "../../../services/couponService";
import CouponToggleSwitch from "./CouponToggleSwitch";

export const ManageCoupon = () => {
  const [pageAccessDetails, setPageAccessDetails] = useState([]);
  const PageLevelAccessurl = "hsn-code";
  const navigate = useNavigate();
  const { pageAccessData } = usePageLevelAccess(PageLevelAccessurl);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [manageCouponCode, setManageCouponCode] = useState([]);
  const [selectedCouponCode, setSelectedCouponCode] = useState(null);

  useEffect(() => {
    if (pageAccessData) {
      if (!pageAccessData.addAccess && !pageAccessData.viewAccess) {
        navigate("/404-error-page");
      } else {
        setPageAccessDetails(pageAccessData);
      }
    } else {
      console.log("No page access details found");
    }
  }, [pageAccessData, navigate]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await fetchCouponCodes();
      if (response && response.data.isSuccess && response.data.result) {
        setManageCouponCode(response.data.result);
      }
    } catch (error) {
      handleErrors(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredRoles = manageCouponCode.filter(
    (couponCodes) =>
      couponCodes.couponCode
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      couponCodes.couponType
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      String(couponCodes.couponValue)
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      String(couponCodes.noOfUsage)
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
  );

  const currentData = paginateData(filteredRoles, currentPage, entriesPerPage);
  const totalPages = calculateTotalPages(filteredRoles.length, entriesPerPage);

  const handleEntriesChange = (value) => {
    setEntriesPerPage(value);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleDelete = async (hsnId) => {
    const confirmed = await confirmDelete("coupon code");
    if (confirmed) {
      try {
        await deleteCouponCode(hsnId);
        setManageCouponCode((prev) => prev.filter((item) => item.id !== hsnId));
        Swal.fire(
          "Deleted!",
          "Coupon Code has been deleted successfully.",
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
  const handleStatusChange = (id, newStatus) => {
    setManageCouponCode((prevProperties) =>
      prevProperties.map((property) =>
        property.id === id ? { ...property, status: newStatus } : property
      )
    );
  };
  return (
    <>
      {pageAccessDetails.addAccess ? (
        <AddCoupon
          editMode={editMode}
          initialData={selectedCouponCode}
          onSuccess={fetchData}
          setSelectedCouponCode={setSelectedCouponCode}
          setEditMode={setEditMode}
        />
      ) : (
        ""
      )}
      {pageAccessDetails.viewAccess ? (
        <div className="row">
          <div className="col-xxl-12">
            <div className="card mt-xxl-n5">
              <div className="card-header">
                <h5 className="mb-sm-2 mt-sm-2">Manage Coupon Code</h5>
              </div>
              <div className="card-body manage-amenity-master-card-body">
                <div className="pagination-details-responsive justify-content-between mb-3">
                  <EntriesDropdown
                    entriesPerPage={entriesPerPage}
                    onEntriesChange={handleEntriesChange}
                  />
                  <div>
                    <input
                      type="text"
                      placeholder="Search..."
                      className="form-control mb-2"
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>
                {loading ? (
                  <Loading />
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle table-bordered">
                      <TableHeader
                        columns={[
                          "#",
                          "Coupon Code",
                          "Coupon Type",
                          "Coupon Value",
                          "Expiry Date",
                          "No Of Usage",
                          "Published?",
                          "Modified On",
                          "Action",
                        ]}
                      />
                      <tbody className="manage-page-group-table-values">
                        {currentData.length === 0 ? (
                          <TableDataStatusError colspan="10" />
                        ) : (
                          currentData.map((item, index) => (
                            <TablesRow
                              key={item.id}
                              rowData={{
                                id:
                                  (currentPage - 1) * entriesPerPage +
                                  index +
                                  1,
                                couponCode: item.couponCode,
                                couponType: item.couponType,
                                couponValue: item.couponValue,
                                noOfUsage: item.noOfUsages,
                                expiryDate: (
                                  <div>
                                    {new Date(item.expiryDate)
                                      .toLocaleString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour12: true,
                                      })
                                      .replace(",", "")}
                                  </div>
                                ),
                                publishOrUnPublish: (
                                  <CouponToggleSwitch
                                    propId={item.id}
                                    initialStatus={
                                      item.published === true
                                        ? "Published"
                                        : "UnPublished"
                                    }
                                    onStatusChange={(newStatus) =>
                                      handleStatusChange(item.id, newStatus)
                                    }
                                  />
                                ),
                                modifiedon: (
                                  <div>
                                    {new Date(item.modifiedOn)
                                      .toLocaleString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: true,
                                      })
                                      .replace(",", "")}
                                    <br />
                                    <span className="text-muted fs-10">
                                      modified by {item.modifiedByUserName}
                                    </span>
                                  </div>
                                ),
                              }}
                              columns={[
                                "id",
                                "couponCode",
                                "couponType",
                                "couponValue",
                                "expiryDate",
                                "noOfUsage",
                                "publishOrUnPublish",
                                "modifiedon",
                              ]}
                              hideIcons={false}
                              onEdit={() => {
                                setSelectedCouponCode(item);
                                setEditMode(true);
                                window.scrollTo({ top: 0, behavior: "smooth" });
                              }}
                              onDelete={() => handleDelete(item.id)}
                              pageLevelAccessData={pageAccessDetails}
                            />
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  totalEntries={filteredRoles.length}
                  entriesPerPage={entriesPerPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
